var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", {
        attrs: { noPadding: "", title: "Export All Data Report", icon: "poll" },
      }),
      _vm._v(" "),
      _vm.globalIsLoading
        ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          attrs: {
            type: "info",
            value:
              !_vm.globalIsLoading && _vm.reportVisibilityOption.length == 0,
          },
        },
        [
          _vm._v(
            "\n    There are no report types activated for this tenant.\n    Please contact the system administrator to activate reports.\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.selectedReport === null && !_vm.globalIsLoading
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _vm.reportTypeIsVisible(_vm.reportObjects.allExport.configKey)
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", md12: "" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c("v-card-title", { staticClass: "headline" }, [
                            _vm._v("\n          Analytical Data\n        "),
                          ]),
                          _vm._v(" "),
                          _c("v-card-text", { staticClass: "pt-0" }, [
                            _vm._v(
                              "\n          All analytical data for selected monitoring component, grouped by station and media type.\n          "
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c("strong", [_vm._v("Note:")]),
                            _vm._v(
                              " It may take a few minutes to export all data.\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { sm6: "", md3: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          solo: "",
                                          items: _vm.medias,
                                          label: "Select Monitoring Component:",
                                          "single-line": "",
                                          "menu-props": "bottom",
                                          "return-object": "",
                                        },
                                        model: {
                                          value: _vm.selectedMedia,
                                          callback: function ($$v) {
                                            _vm.selectedMedia = $$v
                                          },
                                          expression: "selectedMedia",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    loading: _vm.loading,
                                    color: "info",
                                    disabled: !_vm.selectedMedia.length,
                                  },
                                  on: { click: _vm.downloadGroundWaterReport },
                                },
                                [
                                  _c("v-icon", { staticClass: "mr-1" }, [
                                    _vm._v("save_alt"),
                                  ]),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("Button.Download")) +
                                      "\n          "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-snackbar",
                {
                  attrs: {
                    top: true,
                    timeout: _vm.snackTimeout,
                    vertical: true,
                    color: _vm.snackColor,
                  },
                  model: {
                    value: _vm.snackbar,
                    callback: function ($$v) {
                      _vm.snackbar = $$v
                    },
                    expression: "snackbar",
                  },
                },
                [
                  _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", flat: "" },
                      on: {
                        click: function ($event) {
                          _vm.snackbar = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedReport === null
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            _vm._l(_vm.rReports, function (card) {
              return _c(
                "v-flex",
                { key: card.title },
                [
                  _c(
                    "v-card",
                    [
                      _c("Subheader", {
                        attrs: {
                          color: "teal",
                          title: card.Name,
                          "no-search": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-card-media", {
                        attrs: { src: card.PreviewImage, height: "200px" },
                      }),
                      _vm._v(" "),
                      _c("v-card-text", [_vm._v(_vm._s(card.Description))]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        { staticClass: "white" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "warning", light: "" },
                              on: {
                                click: function ($event) {
                                  _vm.selectedReport = card
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("Button.View")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedReport != null
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { md12: "" } },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "teal", dark: "" } },
                    [
                      _c("v-toolbar-title", [
                        _vm._v(_vm._s(_vm.selectedReport.Name)),
                      ]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "warning", light: "" },
                          on: {
                            click: function ($event) {
                              _vm.selectedReport = null
                            },
                          },
                        },
                        [
                          _c("v-icon", [_vm._v("eject")]),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("Button.back")) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _c("iframe", {
                      attrs: {
                        src:
                          "http://hf-gtvan-envirodata:3838/" +
                          _vm.selectedReport.UrlPart,
                        width: "100%",
                        height: "1024px",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "warning", light: "" },
                          on: {
                            click: function ($event) {
                              _vm.selectedReport = null
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.back")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("WaterQualityReportsErrorModal", {
        attrs: {
          data: _vm.errorModalData,
          loading: _vm.errorModalLoading,
          customTitle: _vm.customTitle,
        },
        on: {
          download: _vm.onErrorModalCallback,
          cancel: _vm.onErrorModalClose,
        },
        model: {
          value: _vm.errorModal,
          callback: function ($$v) {
            _vm.errorModal = $$v
          },
          expression: "errorModal",
        },
      }),
      _vm._v(" "),
      _c("ErrorDialog", {
        attrs: {
          data: _vm.errorDialog.data,
          title: _vm.errorDialog.title,
          header: _vm.errorDialog.header,
        },
        model: {
          value: _vm.errorDialog.show,
          callback: function ($$v) {
            _vm.$set(_vm.errorDialog, "show", $$v)
          },
          expression: "errorDialog.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }